import { type ReactNode } from 'react';
import { format } from 'date-fns';
import { Calendar } from '@ics-portal/guardian';
import type { SearchOption } from './types';
import s from './grid-search.module.scss';

interface DateDropdownProps {
    onSelect: (option: SearchOption) => void;
}

export function DateDropdown({ onSelect }: DateDropdownProps): ReactNode {
    return (
        <div className={`${s.dropdown} ${s.dateDropdown}`}>
            <Calendar
                inline
                value={undefined}
                onChange={(e) => {
                    const date = e.value as Date | null;
                    if (date instanceof Date) {
                        onSelect({
                            value: format(date, 'yyyy-MM-dd'),
                            label: format(date, 'dd.MM.yyyy'),
                        });
                    }
                }}
            />
        </div>
    );
}
